import React, { Fragment, useState } from 'react';
import { Box, Slider, Tooltip, Typography } from '@material-ui/core';
import {
	abbreviateNumber,
	formatNumberWithCommas,
	getCurrencyIcon,
	getCurrencyName,
	getOkrProgressDetails,
} from '../../../../config/utils';
import { useTranslation } from 'react-i18next';

export const ProgressBar = (props: any) => {
	const { okr, scoreValue, dueDate, handleSliderChange, drawerOpen } = props;

	const [progressValue, setProgressValue] = useState<any>(scoreValue);
	const { t } = useTranslation();
	const { color } = getOkrProgressDetails({
		value: progressValue,
		dueDate: dueDate,
	});
	const getKrSettingValue = () => {
		return (
			<Fragment>
				{okr.metricId === 1 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{abbreviateNumber(okr.startValue)}%</Typography>
						<Typography variant='h6'>{abbreviateNumber(okr.targetValue)}%</Typography>
					</Box>
				) : okr.metricId === 2 ? (
					<Box className='kr-settings-value'>
						<Tooltip arrow title={formatNumberWithCommas(okr.startValue)}>
							<Typography variant='h6'>
								{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
								{/* {okr.startValue} */}
								{drawerOpen ? formatNumberWithCommas(okr.startValue) : abbreviateNumber(okr.startValue)}
							</Typography>
						</Tooltip>
						<Tooltip arrow title={formatNumberWithCommas(okr.targetValue)}>
							<Typography variant='h6'>
								{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
								{drawerOpen ? formatNumberWithCommas(okr.targetValue) : abbreviateNumber(okr.targetValue)}
							</Typography>
						</Tooltip>
					</Box>
				) : okr.metricId === 3 ? (
					<Box className='kr-settings-value'>
						<Tooltip arrow title={`${formatNumberWithCommas(okr.startValue)}`}>
							<Typography variant='h6'>
								#{drawerOpen ? formatNumberWithCommas(okr.startValue) : abbreviateNumber(okr.startValue)}
							</Typography>
						</Tooltip>
						<Tooltip arrow title={`${formatNumberWithCommas(okr.targetValue)}`}>
							<Typography variant='h6'>
								#{drawerOpen ? formatNumberWithCommas(okr.targetValue) : abbreviateNumber(okr.targetValue)}
							</Typography>
						</Tooltip>
					</Box>
				) : okr.metricId === 4 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{t('notAchieved')}</Typography>
						<Typography variant='h6'>{t('achieved')}</Typography>
					</Box>
				) : okr.metricId === 5 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{abbreviateNumber(okr.startValue)}%</Typography>
						<Typography variant='h6'>{abbreviateNumber(okr.targetValue)}%</Typography>
					</Box>
				) : (
					<></>
				)}
			</Fragment>
		);
	};

	return (
		<Box className='progress-bar-section'>
			<Box className='progress-slider'>
				<Box className={`kr-progress orphan-kr-progress`}>
					{/* {getKrSettingValue()} */}
					<Box className='kr-progress-slider'>
						<Slider
							aria-label={t('MyGoalProgressSlider')}
							style={{ color }}
							// value={okr.currentValue || okr.krCurrentValue}
							value={progressValue}
							min={0}
							max={100}
							valueLabelDisplay='off'
							marks={false}
							step={10}
							onChangeCommitted={handleSliderChange}
							onChange={(e, val) => setProgressValue(val)}
						/>
						<Box className='progress-timestamp-info'>
							<Typography variant='h2'>
								0<sup>%</sup>
							</Typography>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
